import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Dialog from '../../../components/dialog';
import UI from '../../../constants/ui';
import AlertSVG from '../../../img/alert';
import userDevice from './Dialog.helper';

function AlertDialog({ isDialogOpen, primaryAction }) {
  const deviceType = userDevice();

  let contentMessage;
  if (deviceType === 'iphone' || deviceType === 'ipad') {
    contentMessage = UI.IPHONE_ALERT_DESCRIPTION;
  } else {
    contentMessage = UI.ALERT_DESCRIPTION;
  }

  return (
    <Dialog
      content={contentMessage}
      isDialogOpen={isDialogOpen}
      svg={<AlertSVG />}
      primaryAction={primaryAction}
      primaryLabel={UI.OK}
      isAlert
    />
  );
}

AlertDialog.propTypes = {
  isDialogOpen: PropTypes.bool,
  primaryAction: PropTypes.func,
};

AlertDialog.defaultProps = {
  isDialogOpen: false,
  primaryAction: noop,
};

export default AlertDialog;
